import { AxiosRequestConfig } from 'axios';

import Store from '@/main/store';

import Interceptor from '@/classes/Interceptor';

const interceptor = (request: AxiosRequestConfig): AxiosRequestConfig => {
  const token = Store.state.App.Customer.token.getSession().value;
  const withoutHeader = request.headers.head;
  const withHeader = {
    ...request.headers,
    bu: process.env.VUE_APP_BU,
    channel: process.env.VUE_APP_CHANNEL,
    'Content-Type': 'application/json',
    ...token && { Authorization: `Bearer ${token}` },
  };

  let headers = withHeader;

  if (withoutHeader === 'noHeader') {
    headers = {};
  }

  return {
    ...request,
    headers
  };
};

export default new Interceptor({ request: interceptor });
